 <template>
  <div>
    <form class="form-signin" role="form" v-if="!step2" @submit.prevent="onNext">
      <div class="form-group">
        <h2>Forgot Password</h2>
      </div>

      <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

      <div class="form-group">
        <label class="control-label" for="signupEmail">Email</label>
        <input
          id="signupEmail"
          type="email"
          maxlength="50"
          required
          class="form-control"
          v-model="email"
        />
      </div>

      <div class="form-group">
        <button @submit="onNext" class="btn btn-info btn-block">Next</button>
      </div>

      <p>
        <a>
          <router-link to="/register">
            <i class="fa fa-fw fa-group"></i>
            Register
          </router-link>
        </a>

        <a>
          <router-link to="/login">
            <i class="fa fa-fw fa-user"></i>
            Login
          </router-link>
        </a>
      </p>
    </form>

    <!-- STEP TWO STARTS HERE -->
    <form class="form-signin" role="form" v-if="step2" @submit.prevent="onNext">
      <div class="form-group">
        <h2>Forgot Password</h2>
      </div>

      <div v-if="errorMessage!=null" class="alert alert-danger">{{ errorMessage }}</div>

      <div class="form-group">
        <label class="control-label" for="verificationCode">Verification Code</label>
        <input
          id="verificationCode"
          type="verificationCode"
          maxlength="50"
          class="form-control"
          required
          v-model="verificationCode"
        />
      </div>
      <div class="form-group">
        <label class="control-label">New Password</label>
        <input v-model="newPassword" required />
      </div>
      <div class="form-group">
        <button @submit="onNext" id="signupSubmit" class="btn btn-info btn-block">Reset Password</button>
      </div>

      <p>
        <a>
          <router-link to="/forgotPassword">
            <i class="fa fa-fw fa-group"></i> Go back
          </router-link>
        </a>
      </p>
    </form>
  </div>
</template>

 <style lang="css">
</style>

 <script>
import { mapState } from "vuex";

export default {
  name: "ForgotPassword",
  components: {},
  data() {
    return {
      email: "",
      step2: false,
      verificationCode: "",
      newPassword: null
    };
  },
  computed: {
    ...mapState["forgotPasswordErr"],
    errorMessage: function() {
      return this.forgotPasswordErr;
    }
  },
  methods: {
    async onNext() {
      let email = this.email;
      let code = this.verificationCode;
      let password = this.newPassword;
      let errorMessage = this.errorMessage;
      const store = this.$store;
      const router = this.$router;

      if (!this.step2) {
        await store.dispatch("forgotPasswordInit", email);

        if (errorMessage == null) {
          this.step2 = true;
        }
      } else {
        await store.dispatch("forgotPasswordSubmit", {
          email,
          code,
          password
        });
        if (errorMessage == null) {
          router.push({ name: "Login" });
        }
      }
    }
  }
};
</script>